export default "skymp5-front/a345654c21eff568f9c6cb96532f054a.png";